import * as React from "react";
const SvgSortIconBlack = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 8, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.99832 7.07599L0.666383 0.899036L13.3303 0.899037L6.99832 7.07599Z", fill: "black" }));
export default SvgSortIconBlack;
